// Pick a list icon based on the file type. The display name often has no
// extension ("Test Move File"), so fall back to the extension in the URL.
export const getFileIcon = (fileName, fileUrl) => {
  const extFrom = (value) => {
    if (!value) return null;
    const lastSegment = String(value).split("?")[0].split("/").pop() || "";
    if (!lastSegment.includes(".")) return null;
    return lastSegment.split(".").pop().toLowerCase();
  };

  const extension = extFrom(fileName) || extFrom(fileUrl) || "";

  switch (extension) {
    case "pdf":
      return "/assest/folderpng/pdf.png";
    case "xlsx":
    case "xls":
    case "csv":
      return "/assest/folderpng/excel.png";
    case "jpg":
    case "jpeg":
    case "png":
    case "svg":
    case "gif":
    case "webp":
    case "bmp":
      return "/assest/folderpng/jpg_jpeg.png";
    case "doc":
    case "docx":
      return "/assest/folderpng/word.png";
    default:
      return "/assest/folderpng/normal-file.svg";
  }
};
